/** when cypress executes application, it will set is_e2e localStorage entry.
 * configurated by e2e/src/common/setIsE2E function setIsE2E()
*/
export function isE2E() {
  if (typeof window !== 'object') return false;
  if (typeof window.localStorage !== 'object') return false;
  return window.localStorage.getItem('is_e2e') === 'true';
}